import { useState, useRef, useEffect } from 'react'
import { buildComponentAssetPath } from 'utils/assetPaths'
import { fetchDemoPilotAssetAsFile, useDsnProjectUpload } from 'utils/upload'

export const useAssetUpload = ({ projectId, demoPilotProjectId, screenName, componentMetaId, fieldName }) => {
  const { upload } = useDsnProjectUpload(projectId)
  const [isUploading, setIsUploading] = useState(false)
  const isMountedRef = useRef(true)

  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  const uploadAsset = async (asset) => {
    if (!isMountedRef.current) return null
    setIsUploading(true)
    try {
      const file = await fetchDemoPilotAssetAsFile({
        demoPilotProjectId,
        assetId: asset.id,
        fileName: asset.name || asset.originalImage?.alt || `${asset.id}.jpg`,
        throwOnFailure: true,
      })

      if (!isMountedRef.current) return null


      const uploadPath = buildComponentAssetPath({ screenName, componentMetaId, fieldName })
      const result = await upload(file, uploadPath)

      if (!isMountedRef.current) return null

      if (result?.status === 'success' && result?.url) {
        return result.url 
      }
      return null
    } catch (error) {
      if (!isMountedRef.current) return null
      console.error('Failed to upload selected asset to storage', error)
      return null
    } finally {
      if (isMountedRef.current) {
        setIsUploading(false)
      }
    }
  }

  return {
    uploadAsset,
    isLoading: isUploading,
  }
}
